import React from 'react';
import { TypedMemo } from '../../../common/types';

const FormGroupComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="mb-4">{children}</div>;
};

export const FormGroup = TypedMemo(FormGroupComponent);
